<template>
  <div>
    <Loading />
    <div id="backstage" :class="{ displayNone: backstageDisplay }">
      <h1>管理後台</h1>
      <p style="text-align: right;font-size: 12px;margin-right: 20px;">
        憑證剩餘時間：<span
          :class="{ colorStatus: colorStatus }"
          v-text="timeLeft"
        ></span>
        <span
          @click="logout"
          style="border-bottom: 1px solid black;margin-left: 10px;"
          >登出</span
        >
      </p>
      <hr />
      <div class="container">
        <h2>訪客人數</h2>
        <p style="font-size: 12px;">
          單一裝置各瀏覽器造訪首頁，一天計算一次。
        </p>
        <div class="alert alert-primary mb-5" role="alert">
          訪客人數：<span v-text="visitors"></span>人
        </div>
        <h2>價格</h2>
        <table class="table">
          <thead>
            <tr>
              <th scope="col">房型</th>
              <th scope="col">雙人房A</th>
              <th scope="col">雙人房B</th>
              <th scope="col">四人房A</th>
              <th scope="col">四人房B</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope="row">淡季</th>
              <td>NT$ <span v-text="roomDouble_A_off_display"></span></td>
              <td>NT$ <span v-text="roomDouble_B_off_display"></span></td>
              <td>NT$ <span v-text="roomQuad_A_off_display"></span></td>
              <td>NT$ <span v-text="roomQuad_B_off_display"></span></td>
            </tr>
            <tr>
              <th scope="row">旺季</th>
              <td>NT$ <span v-text="roomDouble_A_peak_display"></span></td>
              <td>NT$ <span v-text="roomDouble_B_peak_display"></span></td>
              <td>NT$ <span v-text="roomQuad_A_peak_display"></span></td>
              <td>NT$ <span v-text="roomQuad_B_peak_display"></span></td>
            </tr>
          </tbody>
        </table>
        <label>雙人房A</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">淡季</span>
          </div>
          <input
            type="text"
            class="form-control"
            v-model="roomDouble_A_off_input"
          />
          <div class="input-group-prepend">
            <span class="input-group-text">旺季</span>
          </div>
          <input
            type="text"
            class="form-control"
            v-model="roomDouble_A_peak_input"
          />
        </div>
        <label>雙人房B</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">淡季</span>
          </div>
          <input
            type="text"
            class="form-control"
            v-model="roomDouble_B_off_input"
          />
          <div class="input-group-prepend">
            <span class="input-group-text">旺季</span>
          </div>
          <input
            type="text"
            class="form-control"
            v-model="roomDouble_B_peak_input"
          />
        </div>
        <label>四人房A</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">淡季</span>
          </div>
          <input
            type="text"
            class="form-control"
            v-model="roomQuad_A_off_input"
          />
          <div class="input-group-prepend">
            <span class="input-group-text">旺季</span>
          </div>
          <input
            type="text"
            class="form-control"
            v-model="roomQuad_A_peak_input"
          />
        </div>
        <label>四人房B</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">淡季</span>
          </div>
          <input
            type="text"
            class="form-control"
            v-model="roomQuad_B_off_input"
          />
          <div class="input-group-prepend">
            <span class="input-group-text">旺季</span>
          </div>
          <input
            type="text"
            class="form-control"
            v-model="roomQuad_B_peak_input"
          />
        </div>
        <button
          @click="upDate"
          type="submit"
          class="btn btn-primary btn-lg btn-block mt-3 mb-5"
        >
          更改送出
        </button>
        <h2>帳密重置</h2>
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">帳號</span>
          </div>
          <input type="text" class="form-control" v-model="inputAccount" />
          <div class="input-group-prepend">
            <span class="input-group-text">密碼</span>
          </div>
          <input type="password" class="form-control" v-model="inputPassword" />
        </div>
        <button
          @click="resetNumber"
          type="submit"
          class="btn btn-warning btn-lg btn-block mt-3 mb-5"
        >
          重置送出
        </button>
        <h2>系統紀錄</h2>
        <hr />
        <ul class="list-group list-group-flush mb-5">
          <li
            class="list-group-item list-group-item-action"
            :class="item.judgeColor"
            v-for="item in logStore"
            :key="item.id"
          >
            {{ item.logTime }}
          </li>
        </ul>
        <h2>功能2</h2>
        <hr />
        <div class="form-group">
          <label for="sampleFormControlTextarea1">文字區樣板</label>
          <textarea
            class="form-control"
            id="sampleFormControlTextarea1"
            rows="3"
            placeholder="測試區塊"
          ></textarea>
        </div>
        <button type="submit" class="btn btn-danger btn-lg btn-block mt-3 mb-5">
          按鈕
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from '@/components/Loading.vue'
import firebase from 'firebase/app'

export default {
  name: 'admin',
  data () {
    return {
      backstageDisplay: true,
      LoadingTimer: '',
      countTimer: '',
      timeLeft: '',
      colorStatus: false,
      visitors: '',
      roomDouble_A_off_input: '',
      roomDouble_A_peak_input: '',
      roomDouble_B_off_input: '',
      roomDouble_B_peak_input: '',
      roomQuad_A_off_input: '',
      roomQuad_A_peak_input: '',
      roomQuad_B_off_input: '',
      roomQuad_B_peak_input: '',
      roomDouble_A_off_display: '',
      roomDouble_A_peak_display: '',
      roomDouble_B_off_display: '',
      roomDouble_B_peak_display: '',
      roomQuad_A_off_display: '',
      roomQuad_A_peak_display: '',
      roomQuad_B_off_display: '',
      roomQuad_B_peak_display: '',
      account: '',
      password: '',
      inputAccount: '',
      inputPassword: '',
      logStore: [],
      checkKeyTimer: ''
    }
  },
  components: {
    Loading
  },
  created: function () {
    const vm = this
    firebase
      .database()
      .ref('/')
      .once('value', function (snapshot) {
        vm.roomDouble_A_off_display = snapshot.val().room.double_A.off
        vm.roomDouble_A_peak_display = snapshot.val().room.double_A.peak
        vm.roomDouble_B_off_display = snapshot.val().room.double_B.off
        vm.roomDouble_B_peak_display = snapshot.val().room.double_B.peak
        vm.roomQuad_A_off_display = snapshot.val().room.quad_A.off
        vm.roomQuad_A_peak_display = snapshot.val().room.quad_A.peak
        vm.roomQuad_B_off_display = snapshot.val().room.quad_B.off
        vm.roomQuad_B_peak_display = snapshot.val().room.quad_B.peak
        vm.roomDouble_A_off_input = snapshot.val().room.double_A.off
        vm.roomDouble_A_peak_input = snapshot.val().room.double_A.peak
        vm.roomDouble_B_off_input = snapshot.val().room.double_B.off
        vm.roomDouble_B_peak_input = snapshot.val().room.double_B.peak
        vm.roomQuad_A_off_input = snapshot.val().room.quad_A.off
        vm.roomQuad_A_peak_input = snapshot.val().room.quad_A.peak
        vm.roomQuad_B_off_input = snapshot.val().room.quad_B.off
        vm.roomQuad_B_peak_input = snapshot.val().room.quad_B.peak
        vm.account = snapshot.val().admin.account
        vm.password = snapshot.val().admin.password
        vm.inputAccount = snapshot.val().admin.account
        vm.inputPassword = snapshot.val().admin.password
        vm.visitors = snapshot.val().visitors
      })
  },
  methods: {
    goToLogin () {
      this.$router.push({
        path: '/login'
      })
    },
    upDate () {
      firebase
        .database()
        .ref('room/double_A')
        .set({
          off: this.roomDouble_A_off_input,
          peak: this.roomDouble_A_peak_input
        })
      firebase
        .database()
        .ref('room/double_B')
        .set({
          off: this.roomDouble_B_off_input,
          peak: this.roomDouble_B_peak_input
        })
      firebase
        .database()
        .ref('room/quad_A')
        .set({
          off: this.roomQuad_A_off_input,
          peak: this.roomQuad_A_peak_input
        })
      firebase
        .database()
        .ref('room/quad_B')
        .set({
          off: this.roomQuad_B_off_input,
          peak: this.roomQuad_B_peak_input
        })
      const logDataRef = firebase.database().ref('/logData/')
      let logTimeUpdate = this.timeSnapshotEventLog() + '價錢修改！'
      logDataRef.push({
        logTime: logTimeUpdate,
        judgeColor: 'list-group-item-info'
      })
      alert('系統訊息：\n上傳完成')
      this.$router.go(0)
    },
    resetNumber () {
      const logDataRef = firebase.database().ref('/logData/')
      if (this.inputAccount.trim() === '' || this.inputPassword.trim() === '') {
        alert('請勿空白！')
      } else if (
        this.inputAccount.trim() === this.account.trim() &&
        this.inputPassword.trim() === this.password.trim()
      ) {
        alert('系統訊息：\n帳號密碼未更動！')
      } else {
        firebase
          .database()
          .ref('admin')
          .set({
            account: this.inputAccount.trim(),
            password: this.inputPassword.trim()
          })
        let accountUpdate = this.timeSnapshotEventLog() + '帳密修改！'
        logDataRef.push({
          logTime: accountUpdate,
          judgeColor: 'list-group-item-info'
        })
        alert('系統訊息：\n更改完成！')
      }
    },
    logout () {
      const vm = this
      vm.delCookie(vm.hashDeal().keyStrName)
      this.goToLogin()
    }
  },
  mounted: function () {
    const vm = this
    this.countTimer = setInterval(function () {
      let endDate = new Date(vm.$store.state.termTime)
      let now = new Date()
      let spantime = new Date(endDate - now)
      let formatMin =
        spantime.getMinutes() < 10
          ? '0' + spantime.getMinutes()
          : spantime.getMinutes()
      let formatSec =
        spantime.getSeconds() < 10
          ? '0' + spantime.getSeconds()
          : spantime.getSeconds()
      vm.timeLeft = formatMin + '分' + formatSec + '秒'
      if (vm.timeLeft === '00分00秒') {
        clearInterval(vm.countTimer)
      }
      if (spantime.getMinutes() * 60 + spantime.getSeconds() < 60) {
        vm.colorStatus = true
      } else {
        vm.colorStatus = false
      }
    }, 500)
    firebase
      .database()
      .ref('/logData/')
      .limitToLast(10)
      .once('value', function (snapshot) {
        let eachData = []
        snapshot.forEach(function (item) {
          eachData.push(item.val())
        })
        vm.logStore = eachData.reverse()
      })
    this.checkKeyTimer = setInterval(function () {
      if (
        vm.readCookie(vm.hashDeal().keyStrName) !== vm.hashDeal().keyStrValue
      ) {
        vm.goToLogin()
      }
    }, 500)
    this.LoadingTimer = setTimeout(function () {
      vm.backstageDisplay = false
    }, 2000)
  },
  beforeDestroy () {
    clearInterval(this.countTimer)
    clearInterval(this.checkKeyTimer)
    clearInterval(this.LoadingTimer)
  }
}
</script>

<style scoped lang="scss">
.displayNone {
  display: none !important;
}
h1 {
  text-align: center;
  margin-top: 20px;
}
.colorStatus {
  color: red;
}
/*-----------------------------------------------------------
！手機版！！手機版！！手機版！！小於576px！！手機版！！手機版！！手機版！
------------------------------------------------------------*/
@media screen and (max-width: 576px) {
  li {
    font-size: 15px;
  }
}
/*--------------------------------------------------------
！中間版！中間版！中間版！！577px~991px！！中間版！中間版！中間版！
---------------------------------------------------------*/
@media (min-width: 577px) and (max-width: 991px) {
  li {
    font-size: 16px;
  }
}
/*--------------------------------------------------------
！電腦版！！電腦版！！電腦版！！大於992px~1199px！！電腦版！！電腦版！！電腦版！
---------------------------------------------------------*/
@media (min-width: 992px) and (max-width: 1199px) {
  li {
    font-size: 20px;
  }
}
/*--------------------------------------------------------
！螢幕版！！螢幕版！！螢幕版！！大於1200px！！螢幕版！！螢幕版！！螢幕版！
---------------------------------------------------------*/
@media screen and (min-width: 1200px) {
  li {
    font-size: 25px;
  }
}
</style>
